(function ($) {

  if ($('.filters-block.fellow').length > 0) {
    // // Fellows filter
    // function wrappBlock() {
    //   $(".filters-block.fellow .filter-wrapper .filter-results").each(function (index, sel) {
    //     // Wrap all div after h3
    //     $.each($('.filters-block.fellow .filter-wrapper .filter-results h3'), function (i, v) {
    //       $(v).nextUntil($('h3')).wrapAll('<div class="block-wrapper fellow-card-wrapper"></div>');
    //     });

    //     var o;
    //     var itemLength1 = $(".filters-block .filter-results h3").length;
    //     for (var j = 0; j < itemLength1; j += 1) {
    //       if (j < itemLength1) {
    //         o = j + 1;
    //       }
    //       var row1 = $(sel).find("h3").slice(j, o);
    //       row1.wrapAll("<div class='block-wrapper fellow-title'></div>");
    //     }

    //     //Wrap 2 divs in 1 div
    //     var p;
    //     var itemLength2 = $(".filters-block .filter-results .block-wrapper").length;
    //     for (var l = 0; l < itemLength2; l += 2) {
    //       if (l < itemLength2) {
    //         p = l + 2;
    //       }
    //       var row2 = $(sel).find(".block-wrapper").slice(l, p);
    //       row2.wrapAll("<div class='fellow-result'></div>");
    //     }

    //     $('.filters-block.fellow .fellow-result').each(function () {
    //       $(this).find('.fellow-card-wrapper').append('<div class="btn-wrap"><span class="link-more"><span>View More</span></span></div>');
    //       $(this).find('.fellow-title').append('<span></span>');
    //       $(this).find('.fellow-title').append('<div class="tooltip">\n' +
    //         '                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n' +
    //         '                                <defs>\n' +
    //         '                                    <style>\n' +
    //         '                                        .cls-1, .cls-4 {\n' +
    //         '                                            fill: none;\n' +
    //         '                                        }\n' +
    //         '\n' +
    //         '                                        .cls-1 {\n' +
    //         '                                            stroke: #fff;\n' +
    //         '                                        }\n' +
    //         '\n' +
    //         '                                        .cls-2 {\n' +
    //         '                                            fill: #fff;\n' +
    //         '                                            font-size: 18px;\n' +
    //         '                                            font-family: Helvetica-Bold, Helvetica;\n' +
    //         '                                            font-weight: 700;\n' +
    //         '                                        }\n' +
    //         '\n' +
    //         '                                        .cls-3 {\n' +
    //         '                                            stroke: none;\n' +
    //         '                                        }\n' +
    //         '                                    </style>\n' +
    //         '                                </defs>\n' +
    //         '                                <g id="Group_4929" data-name="Group 4929" transform="translate(0.18 0.18)">\n' +
    //         '                                    <g id="Ellipse_299" data-name="Ellipse 299" class="cls-1" transform="translate(-0.18 -0.18)">\n' +
    //         '                                        <circle class="cls-3" cx="12" cy="12" r="12"></circle>\n' +
    //         '                                        <circle class="cls-4" cx="12" cy="12" r="11.5"></circle>\n' +
    //         '                                    </g>\n' +
    //         '                                    <text id="i" class="cls-2" transform="translate(9.32 17.82)">\n' +
    //         '                                        <tspan x="0" y="0">i</tspan>\n' +
    //         '                                    </text>\n' +
    //         '                                </g>\n' +
    //         '                            </svg>\n' +
    //         '\n' +
    //         '                            <small></small>\n' +
    //         '                        </div>');
    //     });
    //   });
    // }

    // function update_Dropdown() {
    //   // Update Research Interest Text
    //   $(".filters-block.fellow .form-item-field-tref-topic-target-id #edit-field-tref-topic-target-id option").each(function (index) {
    //     var text = $(this).text().replace(new RegExp('-', 'g'), "");
    //     var val = $(this).val();
    //     var val1 = text.charAt(0);

    //     $('.filters-block.fellow .interest').append('<li></li>');
    //     setTimeout(function () {
    //       $('.filters-block.fellow .interest li:eq(' + (index) + ')').html(text).attr('value', val);
    //       $('.filters-block.fellow .interest li:eq(' + (index) + ')').attr('list_alpha', val1);
    //     }, 300);
    //   });

    //   // Research Interest list click event
    //   $('.filters-block.fellow .interest li').on("click", function () {
    //     var selectedItemVal, itemVal, selectedTxt;
    //     itemVal = $(this).attr("value");
    //     var itemClass = $(this).attr("class");
    //     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-topic-target-id select option").each(function () {
    //       selectedItemVal = $(this).attr("value");
    //       selectedTxt = $(this).text();
    //       if (itemClass != "selected") {
    //         if (itemVal === selectedItemVal) {
    //           $(this).attr("selected", "selected");
    //         }
    //       }
    //       else {
    //         if (itemVal === selectedItemVal) {
    //           $(this).removeAttr("selected");
    //         }
    //       }
    //     });

    //     $(".filters-block.fellow .form-actions .form-submit").trigger("click");
    //   });

    //   // Update Expertise Text
    //   var s1 = [];
    //   $(".filters-block.fellow .form-item-field-tref-expertise-target-id #edit-field-tref-expertise-target-id option").each(function (index) {
    //     var text = $(this).text().replace(new RegExp('-', 'g'), "");
    //     var we_val = $(this).val();
    //     var val1 = $(this).text().charAt(0);
    //     $(this).attr('alphabet', val1);

    //     const c1 = text.charAt(0);
    //     const fellow_html = text;

    //     // Create Object
    //     const s2 = {
    //       first_latter: c1,
    //       content: fellow_html,
    //       we_value: we_val
    //     }
    //     s1.push(s2);

    //     // Sorting ASC
    //     s1 = (
    //       s1.sort(function (a, b) {
    //         return a['first_latter'].localeCompare(b['first_latter']);
    //       })
    //     );

    //     // Fetch content from object
    //     $('.filters-block.fellow .expertise').append('<li></li>');
    //     for (var i = 0; i < s1.length; i++) {
    //       $('.filters-block.fellow .expertise li:eq(' + (i) + ')').html(s1[i]['content']).attr('value', s1[i]['we_value']);
    //       $('.filters-block.fellow .expertise li:eq(' + (i) + ')').attr('list_alpha', s1[i]['first_latter']);
    //     }
    //   });

    //   // Expertise list click event
    //   $('.filters-block.fellow .expertise li').on("click", function () {
    //     var selectedItemVal, itemVal, selectedTxt;
    //     itemVal = $(this).attr("value");
    //     var itemClass = $(this).attr("class");
    //     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-expertise-target-id select option").each(function () {
    //       selectedItemVal = $(this).attr("value");
    //       selectedTxt = $(this).text();
    //       if (itemClass != "selected") {
    //         if (itemVal === selectedItemVal) {
    //           $(this).attr("selected", "selected");
    //         }
    //       }
    //       else {
    //         if (itemVal === selectedItemVal) {
    //           $(this).removeAttr("selected");
    //         }
    //       }
    //     });

    //     $(".filters-block.fellow .form-actions .form-submit").trigger("click");
    //   });

    //   // Update Fellow Type Text
    //   $(".filters-block.fellow .form-item-field-tref-fellow-type-target-id-1 #edit-field-tref-fellow-type-target-id-1 option").each(function (index) {
    //     var text = $(this).text().replace(new RegExp('-', 'g'), "");
    //     var val = $(this).val();
    //     var val1 = text.charAt(0);
    //     $('.filters-block.fellow .fellow-type').append('<li></li>');
    //     setTimeout(function () {
    //       $('.filters-block.fellow .fellow-type li:eq(' + (index) + ')').html(text).attr('value', val);
    //       $('.filters-block.fellow .fellow-type li:eq(' + (index) + ')').attr('list_alpha', val1);
    //     }, 300);
    //   });

    //   // Remove Unnecessary Fellow Type From List Dropdown
    //   setTimeout(function () {
    //     $.getJSON("/json/fellowterm", function (data1) {
    //       var items1 = [];
    //       $.each(data1, function (key1, val1) {
    //         items1.push(val1);
    //       });

    //       $('.filters-block.fellow .fellow-type li').each(function () {
    //         var list_title = $(this).text();
    //         for (var i = 0; i < items1.length; i++) {
    //           const name = items1[i]["name"];
    //           if (list_title.trim().toLowerCase() === name.trim().toLowerCase()) {
    //             $(this).addClass('match');
    //           }
    //         }

    //         if ($(this).hasClass('match')) {

    //         } else {
    //           $(this).remove();
    //         }
    //       });
    //     });
    //   }, 1000);

    //   setTimeout(function () {
    //     // Hide Unnecessary Fellow Type Alpha
    //     $('.filters-block.fellow .fellow-type li').each(function () {
    //       var val = $(this).attr('list_alpha');
    //       $('.filters-block.fellow .type-alpha li').each(function () {
    //         var value = $(this).attr('value');
    //         if (val === value) {
    //           $(this).addClass('match');
    //         } else {

    //         }
    //       });
    //     });

    //     // Hide Unnecessary Expertise Alpha
    //     $('.filters-block.fellow .expertise li').each(function () {
    //       var val = $(this).attr('list_alpha');
    //       $('.filters-block.fellow .expertise-alph li').each(function () {
    //         var value = $(this).attr('value');
    //         if (val === value) {
    //           $(this).addClass('match');
    //         }
    //       });
    //     });

    //     // Hide Unnecessary Interest Alpha
    //     $('.filters-block.fellow .interest li').each(function () {
    //       var val = $(this).attr('list_alpha');
    //       $('.filters-block.fellow .interest-alph li').each(function () {
    //         var value = $(this).attr('value');
    //         if (val === value) {
    //           $(this).addClass('match');
    //         }
    //       });
    //     });
    //   }, 3000);

    //   // Fellow Type list click event
    //   $('.filters-block.fellow .fellow-type li').on("click", function () {
    //     var selectedItemVal, itemVal, selectedTxt;
    //     itemVal = $(this).attr("value");
    //     var itemClass = $(this).attr("class");
    //     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-fellow-type-target-id-1 select option").each(function () {
    //       selectedItemVal = $(this).attr("value");
    //       selectedTxt = $(this).text();
    //       if (itemClass != "selected") {
    //         if (itemVal === selectedItemVal) {
    //           $(this).attr("selected", "selected");
    //         }
    //       }
    //       else {
    //         if (itemVal === selectedItemVal) {
    //           $(this).removeAttr("selected");
    //         }
    //       }
    //     });

    //     $(".filters-block.fellow .form-actions .form-submit").trigger("click");
    //   });

    // }

    // function json_Data() {
    //   // Get Json data
    //   $.getJSON("/json/fellowterm", function (data) {
    //     var items = [];
    //     $.each(data, function (key, val) {
    //       items.push(val);
    //     });

    //     $('.filters-block .fellow-title').each(function () {
    //       let title = $(this).find('h3').text();
    //       if ($(this).find('h3 span').length > 0) {
    //         title = $(this).find('h3 span').text();
    //       } else {
    //         $(this).find('h3').html("<span>" + title + "</span><em>(0)</em>");
    //       }
    //       for (var i = 0; i < items.length; i++) {
    //         const name = items[i]["name"];
    //         var name1 = items[i]["name_1"];
    //         if (title.trim().toLowerCase() === name.trim().toLowerCase()) {
    //           $(this).find('h3').html("<span>" + title + "</span><em>(" + items[i]["uuid"] + ")</em>");
    //           $(this).find('small').html(items[i]["description__value"]);
    //           $(this).find('h3').addClass(name1);
    //           if (items[i]["description__value"] === "") {
    //             $(this).find('.tooltip').remove();
    //           }
    //         }
    //       }

    //       var len = $(this).parent().find('.fellow-card-wrapper .fellow-card').length;
    //       $(this).find('h3 em').text("(" + len + ")");

    //     });

    //     // Remove Unnecessary Fellow Type From form
    //     $("#views-exposed-form-all-fellow-block-1 .form-item-field-tref-fellow-type-target-id-1 select option").each(function () {
    //       var list_title = $(this).text();
    //       for (var i = 0; i < items.length; i++) {
    //         const name1 = items[i]["name"];
    //         if (list_title.trim().toLowerCase() === name1.trim().toLowerCase()) {
    //           $(this).addClass('match');
    //         }
    //       }

    //       if ($(this).hasClass('match')) {

    //       } else {
    //         $(this).remove();
    //       }
    //     });
    //   });

    // }


    /* Load more click count. */
    // var item_show = 16,
    //   length = '';

    // /* Function to hide and show element on Load */
    // function load_OnReady() {
    //   $('.filters-block.fellow .fellow-card-wrapper').find('.fellow-card').each(function () {
    //     length = $(this).parents('.filters-block.fellow .fellow-card-wrapper').find('.fellow-card').length;
    //     var index = $(this).index();
    //     if (index >= item_show) {
    //       $(this).css('display', 'none');
    //     } else {
    //       $(this).css('display', 'block');
    //     }
    //     if (length <= item_show) {
    //       $(this).parents('.fellow-card-wrapper').find('.btn-wrap').css('display', 'none');
    //     } else {
    //       $(this).parents('.fellow-card-wrapper').find('.btn-wrap').css('display', 'block');
    //     }
    //   });
    //   $('.filters-block .filter-results .fellow-result .fellow-card-wrapper .fellow-card').matchHeight();
    // }

    // function accordian() {
    //   //Accordian code starts here
    //   $('.filters-block .filter-results .fellow-result:lt(5)').find('.fellow-card-wrapper').slideDown();
    //   $('.filters-block .filter-results .fellow-result:lt(5)').find('.fellow-title').addClass('minus');
    //   $('.filters-block .filter-results .fellow-result .fellow-title').on('click', function () {
    //     $(this).next('.fellow-card-wrapper').slideToggle();
    //     $(this).toggleClass('minus');
    //   });
    //   var div_width = $('.filters-block.fellow .filter-wrapper .wrapper').width();
    //   $('.filters-block.fellow .filter-wrapper .wrapper .filter-dropdown .filter-items').css({ 'width': +div_width });

    // }

    // // Author Filter

    // function drop_Alpha1() {
    //   // fellow-type alpha append
    //   var arr = [], arr1 = [];
    //   $(".filters-block.fellow .form-item-field-tref-fellow-type-target-id-1 select option").each(function () {
    //     var val = $(this).text().charAt(0);
    //     $(this).attr('alphabet', val);
    //     var list_flag = 0;

    //     for (var i = 0; i < arr.length; i++) {
    //       if (arr[i] === val) {
    //         list_flag = 1;
    //       }
    //     }
    //     // Push unique value in array
    //     if (list_flag === 0) {
    //       arr.push(val);
    //     }
    //   });

    //   // Sort value in array
    //   arr1 = (
    //     arr.sort(function (a, b) {
    //       return a[0].localeCompare(b[0]);
    //     })
    //   );
    //   // Print value in html
    //   for (var i = 0; i < arr1.length; i++) {
    //     $('.filters-block.fellow .type-alpha').append("<li value=" + arr1[i] + ">" + arr1[i] + "</li>");
    //   }
    // }

    // function drop_Author() {
    //   $(".filters-block.fellow .form-item-field-tref-expertise-target-id select option").each(function () {
    //     var text = $(this).text();
    //     var val = text.charAt(0);
    //     $(this).attr('alphabet', val);
    //   });
    // }

    // function drop_Author1() {
    //   $(".filters-block.fellow .form-item-field-tref-fellow-type-target-id-1 select option").each(function () {
    //     var text = $(this).text();
    //     var val = text.charAt(0);
    //     $(this).attr('alphabet', val);
    //   });
    // }

    // function drop_Author2() {
    //   $(".filters-block.fellow .form-item-field-tref-topic-target-id select option").each(function () {
    //     var text = $(this).text();
    //     var val = text.charAt(0);
    //     $(this).attr('alphabet', val);
    //   });
    // }

    function abc_scroll() {
      $('.filters-block.fellow .abc-filter .col-wrap label').removeClass('show');
      $('.filters-block.fellow .fellow-title h3').each(function () {
        var value = $(this).attr('class');
        $('.filters-block.fellow .abc-filter .col-wrap label').each(function () {
          var value2 = $(this).attr('value');
          if (value === value2) {
            $(this).addClass('show');
          } else {
            // $(this).addClass('hide');
          }
        });

      });
    }

    // var flag = 1;
    // $(document).ready(function () {
    //   wrappBlock();
    //   json_Data();
    //   load_OnReady();
    //   update_Dropdown();

    //   drop_Alpha1();
    //   drop_Author();
    //   drop_Author1();
    //   drop_Author2();

    //   $('.filters-block.fellow .filter-dropdown .filter-items ul li').on('click', function () {
    //     flag = 0;
    //     $(this).parents('.filter-items').addClass('clicked');
    //   });

    //   $('.filters-block.fellow .reset').on('click', function () {
    //     flag = 0;
    //   });

    //   $('.filters-block.fellow .filter-data').on('click', function (e) {
    //     e.stopPropagation();
    //     flag = 0;
    //   });

    //   $('.filters-block.fellow  .filter-dropdown.search form input').on('keyup', function () {
    //     flag = 0;
    //   });
    // });

    $(document).ajaxStop(function () {
      // if (flag === 0) {
      //   wrappBlock();
      //   json_Data();
      //   load_OnReady();
      //   accordian();
      //   drop_Author();
      //   drop_Author1();
      //   drop_Author2();
      //   flag = 1;

      //   $('.filters-block.fellow .sort-by span[value="name"]').removeClass('active');
      //   $('.filters-block.fellow .sort-by span[value="weight"]').addClass('active');
      //   $('.filters-block.fellow .filter-dropdown .filter-items').removeClass('clicked');
      // }
      setTimeout(function () {
        abc_scroll();
      }, 1000);
    });

    // Link More Functionality
    // $(document).on('click', '.filters-block .fellow-result .fellow-card-wrapper .btn-wrap .link-more', function () {
    //   $(this).parent().parent().find('.fellow-card').css({
    //     'display': 'block'
    //   });
    //   $(this).parent().parent().find('.btn-wrap').css({
    //     'display': 'none'
    //   });
    // });

    // function sortAlpha() {
    //   $('.filters-block.fellow .filter-results .fellow-result').each(function () {
    //     var s1 = [];
    //     $(this).find('.fellow-card').each(function () {
    //       const text = $(this).find('.content h6.alpha').text();
    //       const c1 = text.charAt(0);
    //       const fellow_html = $(this).html();
    //       var height = $(this).css('height');

    //       // Create Object
    //       const s2 = {
    //         first_latter: c1,
    //         content: fellow_html,
    //         height: height
    //       }
    //       s1.push(s2);
    //     });

    //     // Sorting ASC
    //     s1 = (
    //       s1.sort(function (a, b) {
    //         return a['first_latter'].localeCompare(b['first_latter']);
    //       })
    //     );

    //     // Fetch content from object
    //     $(this).find('.fellow-card-wrapper').empty();
    //     for (var i = 0; i < s1.length; i++) {
    //       $(this).find('.fellow-card-wrapper').append('<div class="fellow-card">' + s1[i]['content'] + '</div>');
    //     }

    //     $(this).find('.fellow-card-wrapper').append('<div class="btn-wrap"><span class="link-more"><span>View More</span></span></div>');
    //     load_OnReady();
    //   });
    // }

    // // Sort Filter
    // $('.filters-block.fellow .show-result .sort-by span').on('click', function () {
    //   var value = $(this).attr('value');
    //   $(this).siblings().removeClass('active');
    //   $(this).addClass('active');
    //   if (value === "weight") {
    //     $('#views-exposed-form-all-fellow-block-1 .form-item-sort-by select').val(value).trigger('change');
    //     $('.filters-block .form-actions .form-submit').trigger('click');
    //   }

    //   if (value === "name") {
    //     sortAlpha();
    //   }

    //   flag = 0;
    // });

    var fl = 0;
    $(window).on('load', function () {
      setTimeout(function () {
        abc_scroll();
       // $(".filters-block.fellow").animate({ 'opacity': 1 }, 300);
      }, 1000);
      // // Functionality for tag name on load
      // var page_url = window.location.href;
      // if (page_url.indexOf('/') > -1) {
      //   var array1 = page_url.split('?');
      //   var string1 = array1[1];
      //   if (array1[1]) {
      //     string1 = string1.split('=')[0];
      //     if (string1 === "fellow-type" || string1 === "research-interest" || string1 === "expertise" || string1 === "search") {

      //       if ($('.toolbar-tray-open').length > 0) {
      //         $(".filters-block.fellow").css({ 'opacity': 0 });
      //         $(document).ajaxSuccess(function () {
      //           setTimeout(function () {
      //             if (fl === 0) {
      //               // wrappBlock();
      //               // json_Data();
      //               // load_OnReady();
      //               // accordian();
      //               // drop_Author();
      //               // drop_Author1();
      //               // drop_Author2();
      //               setTimeout(function () {
      //                 abc_scroll();
      //                // $(".filters-block.fellow").animate({ 'opacity': 1 }, 300);
      //               }, 1000);

      //               fl = 1;
      //             }
      //           }, 2500);
      //         });
      //       } else {
      //         setTimeout(function () {
      //           flag = 0;
      //         }, 400);
      //       }

      //       setTimeout(function () {
      //         var content = $('.filters-block');
      //         $('html, body').animate({ 'scrollTop': $(content).offset().top }, 800, 'swing');
      //       }, 1500);
      //     }
      //   }
      // }
    });

    setTimeout(function () {
      abc_scroll();
    }, 5000);
    $('.filters-block.fellow .abc-filter .col-wrap label').on('click', function () {
      var content = $(this).attr('value');
      $('html, body').animate({ 'scrollTop': $('.' + content + '').offset().top - 140 }, 800, 'swing');

      if (!$('.filters-block .filter-results .fellow-result .fellow-title .' + content + '').parent().hasClass('minus')) {
        $('.filters-block .filter-results .fellow-result .fellow-title .' + content + '').parent().trigger("click");
      }

    });
  }

})
  (jQuery);
